import React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NavigationBar from "./ui/NavigationBar";
import StudentHome from "./students/StudentHome";
import CreateViajeForm from "./admin/forms/viaje/CreateViajeForm";
import CreateProfessorForm from "./admin/forms/profesor/CreateProfessorForm";
import ViajesList from "./admin/viajes/ViajesList";
import UsersList from "./admin/students/AlumnosList";
import EditViajeForm from "./admin/forms/viaje/EditViajeForm";
import CreateStudentForm from "./admin/forms/student/CreateStudentForm";
import GruposList from "./admin/grupos/GruposList";
import InfoGrupo from "./admin/grupos/InfoGrupo";
import AdminHome from "./admin/Home";
import Professor from "./professors/ProfessorActions";
import PrivateRoute from "./PrivateRoute";
import ProfessorRoute from "./professors/ProfessorRoute";
import AlumnosList from "./professors/AlumnosList";
import ColegioGruposList from "./professors/ColegioGruposList";
import EditGrupo from "./admin/forms/grupo/EditGrupo";
import CreateGrupo from "./admin/forms/grupo/CreateGrupo";
import CreateActividad from "./admin/actividades/CreateActividad";
import Actividades from "./admin/actividades/Actividades";
import Developer from "./admin/Developer";

import { selectUserType } from "../redux/selectors/auth";
import { getFirebaseData } from "../redux/actions/network";

class Routing extends React.Component {
  componentDidMount() {
    const { getFirebaseData } = this.props;
    getFirebaseData(this.props);
  }

  render() {
    const { isAdmin, location, isProfessor, isStudent } = this.props;
    return (
      <Router>
        <React.Fragment>
          <NavigationBar />
          {isAdmin && (
            <Switch>
              <PrivateRoute exact path="/" component={AdminHome} />
              <PrivateRoute exact path="/admin" component={AdminHome} />
              <PrivateRoute exact path="/developer" component={Developer} />
              <PrivateRoute
                exact
                path="/viajes/new"
                component={CreateViajeForm}
              />
              <PrivateRoute
                exact
                path="/viajes/:id/edit"
                component={EditViajeForm}
              />
              <PrivateRoute path="/viajes" component={ViajesList} exact />

              <PrivateRoute
                path="/student/new"
                component={CreateStudentForm}
                exact
              />
              <PrivateRoute path="/users" component={UsersList} exact />

              <PrivateRoute path="/grupos/new" component={CreateGrupo} exact />
              <PrivateRoute path="/grupos" component={GruposList} exact />
              <PrivateRoute
                exact
                path="/grupos/edit/:id"
                component={EditGrupo}
              />
              <PrivateRoute exact path="/grupos/:id" component={InfoGrupo} />

              <PrivateRoute
                path="/profesores/new"
                component={CreateProfessorForm}
                exact
              />
              <PrivateRoute path="/actividades" component={Actividades} exact />

              <PrivateRoute
                path="/actividades/new"
                component={CreateActividad}
                exact
              />
            </Switch>
          )}
          {isProfessor && (
            <Switch>
              <ProfessorRoute path="/" component={Professor} exact />
              <ProfessorRoute path="/alumnos" component={AlumnosList} exact />
              <ProfessorRoute
                path="/grupos"
                component={ColegioGruposList}
                exact
              />
              <ProfessorRoute exact path="/grupos/:id" component={InfoGrupo} />
            </Switch>
          )}
          {isStudent && (
            <Switch>
              <Route exact path="/" component={StudentHome} />
              <Redirect
                to={{
                  pathname: "/",
                  state: { from: location }
                }}
              />
            </Switch>
          )}
        </React.Fragment>
      </Router>
    );
  }
}

const mapStateToProps = state => {
  const isAdmin = selectUserType(state) === "admin";
  const isProfessor = selectUserType(state) === "professor";
  const isStudent = selectUserType(state) === "student";

  return {
    isAdmin,
    isProfessor,
    isStudent
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getFirebaseData }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routing);
